<template lang="html">
  <div class="particles">
    <vue-particles
      color="#f9f9f9"
      :particleOpacity="0.3"
      :particlesNumber="100"
      shapeType="star"
      :particleSize="4"
      :lineLinked="false"
      :moveSpeed=".5"
      :hoverEffect="false"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    >
    </vue-particles>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>

  .particles
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%

    #particles-js
      height: 100%

</style>
